import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { MultiLanguageUrl } from "../../../constants/multiLanguage.constant";

type Props = {};

const SiteSocialNetworkComponent = (props: Props) => {
  const { i18n, t } = useTranslation();

  return (
    <section
      id="footer-socialNetwork"
      className="gap-3 py-5 pb-4 d-flex flex-column justify-content-center align-content-center align-items-center bg-firstColor"
    >
      <Container>
        <Row>
          <Col>
            <Row>
              <Col lg="7" className="px-3">
                <Row className="mb-2">
                  <Col>
                    <Link
                      to={""}
                      className="text-decoration-none color-twelveColor"
                    >
                      <span className="fs-2 fw-bolder font-poppins">
                        LouiseBot
                      </span>
                    </Link>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className="color-sevenColor fs-5 font-sofiaSans">
                      {t("home/SiteSocialNetwork/text-01")}
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col lg="1"></Col>
              <Col lg="4" className="px-3">
                <Row className="mb-2">
                  <Col>
                    <span className="fs-3 fw-bolder font-poppins color-sevenColor">
                      {t("home/SiteSocialNetwork/link-01")}
                    </span>
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col>
                    <Row>
                      <Col>
                        <Link
                          className="nav-link color-sevenColor font-sofiaSans"
                          to={`/${
                            MultiLanguageUrl[i18n.language] || "en-US"
                          }/plans`}
                        >
                          {t("home/SiteSocialNetwork/link-02")}
                        </Link>
                      </Col>
                      <Col>
                        <Link
                          className="nav-link color-sevenColor font-sofiaSans"
                          target="_blank"
                          to={`/${
                            MultiLanguageUrl[i18n.language] || "en-US"
                          }/terms-of-service`}
                        >
                          {t("home/SiteSocialNetwork/link-03")}
                        </Link>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <Link
                      className="nav-link color-sevenColor font-sofiaSans"
                      to={`/${
                        MultiLanguageUrl[i18n.language] || "en-US"
                      }/contact-us`}
                    >
                      {t("home/SiteSocialNetwork/link-04")}
                    </Link>
                  </Col>
                  <Col>
                    <Link
                      target="_blank"
                      className="nav-link color-sevenColor font-sofiaSans"
                      to={`/${
                        MultiLanguageUrl[i18n.language] || "en-US"
                      }/frequently-asked-questions`}
                    >
                      {t("home/SiteSocialNetwork/link-05")}
                    </Link>
                  </Col>
                </Row>
              </Col>
              {/* <Col lg="4" className="px-3">
        <Row className="mb-2">
         <Col>
          <span className="fs-3 fw-bolder font-poppins color-sevenColor">
           Follow us on social media
          </span>
         </Col>
        </Row>
        <Row>
         <Col>
          <Row className="d-flex gap-2 mt-1 px-3 ">
           <Col className="footer-icon bg-fifteenColor">
            <BsTwitter className="color-twentyOneColor" />
           </Col>
           <Col className="footer-icon">
            <FaFacebookF className="color-twentyOneColor" />
           </Col>
           <Col className="footer-icon">
            <FaLinkedinIn className="color-twentyOneColor" />
           </Col>
           <Col className="footer-icon">
            <AiFillInstagram className="color-twentyOneColor" />
           </Col>
          </Row>
         </Col>
        </Row>
       </Col> */}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SiteSocialNetworkComponent;
